
export class UserManagementData {
  data: any;
}
